var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.523 18.4C17.2465 18.4 16.223 19.4235 16.223 20.7C16.223 21.31 16.4654 21.895 16.8967 22.3263C17.328 22.7577 17.913 23 18.523 23C19.133 23 19.7181 22.7577 20.1494 22.3263C20.5807 21.895 20.823 21.31 20.823 20.7C20.823 20.09 20.5807 19.505 20.1494 19.0737C19.7181 18.6423 19.133 18.4 18.523 18.4ZM0.123047 0V2.3H2.42305L6.56305 11.0285L4.99905 13.846C4.82655 14.168 4.72305 14.5475 4.72305 14.95C4.72305 15.56 4.96537 16.145 5.3967 16.5763C5.82803 17.0077 6.41305 17.25 7.02305 17.25H20.823V14.95H7.50605C7.4298 14.95 7.35667 14.9197 7.30275 14.8658C7.24884 14.8119 7.21855 14.7388 7.21855 14.6625C7.21855 14.605 7.23005 14.559 7.25305 14.5245L8.28805 12.65H16.8555C17.718 12.65 18.477 12.167 18.868 11.4655L22.985 4.025C23.0655 3.841 23.123 3.6455 23.123 3.45C23.123 3.145 23.0019 2.85249 22.7862 2.63683C22.5706 2.42116 22.278 2.3 21.973 2.3H4.96455L3.88355 0M7.02305 18.4C5.74655 18.4 4.72305 19.4235 4.72305 20.7C4.72305 21.31 4.96537 21.895 5.3967 22.3263C5.82803 22.7577 6.41305 23 7.02305 23C7.63304 23 8.21806 22.7577 8.64939 22.3263C9.08073 21.895 9.32305 21.31 9.32305 20.7C9.32305 20.09 9.08073 19.505 8.64939 19.0737C8.21806 18.6423 7.63304 18.4 7.02305 18.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckout);
export default __webpack_public_path__ + "static/media/checkout.f036e0ec8e735d268efd2a7f6a73ed54.svg";
export { ForwardRef as ReactComponent };